import React from 'react';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import type { MetricsFrameworkTabId } from '../types';
import MetricsFrameworkTabView from '../components/MetricsFrameworkTabView';
import {
  IMPACT_HUB_BASE_PATH,
  METRICS_FRAMEWORK_VIEWS,
  METRICS_FRAMEWORK_VIEW_CONFIG,
} from './viewConfig';

const createProtectedTabViews = (): Record<
  MetricsFrameworkTabId,
  React.ComponentType<any>
> => {
  const views = {} as Record<MetricsFrameworkTabId, React.ComponentType<any>>;

  METRICS_FRAMEWORK_VIEWS.forEach(view => {
    const TabView = () => <MetricsFrameworkTabView view={view} />;
    // Protect by exact path — same as UserManagement/Users → /user-management?view=users
    views[view] = withResourceProtection(
      TabView,
      METRICS_FRAMEWORK_VIEW_CONFIG[view].path,
    ) as React.ComponentType<any>;
  });

  return views;
};

export const METRICS_FRAMEWORK_PROTECTED_TAB_VIEWS = createProtectedTabViews();

export const METRICS_FRAMEWORK_PROTECTED_TAB_VIEWS_BY_BASE_PATH: Record<
  string,
  Record<MetricsFrameworkTabId, React.ComponentType<any>>
> = {
  [IMPACT_HUB_BASE_PATH]: METRICS_FRAMEWORK_PROTECTED_TAB_VIEWS,
};
